import { hasStorage } from '../../utils/has-storage';
import { isBrowser } from '../../utils/is-browser';

export const SMART_APP_BANNER_STORAGE_KEY = 'smartAppBannerDismissedAt';
export const SMART_APP_BANNER_DISMISS_TTL_MS = 30 * 24 * 60 * 60 * 1000;

export const readSmartAppBannerDismissedAt = (): number | null => {
    if (!isBrowser() || !hasStorage('localStorage')) {
        return null;
    }

    const raw = window.localStorage.getItem(SMART_APP_BANNER_STORAGE_KEY);
    if (!raw) {
        return null;
    }

    const dismissedAt = Date.parse(raw);
    return Number.isNaN(dismissedAt) ? null : dismissedAt;
};

export const isSmartAppBannerDismissed = (now = Date.now()): boolean => {
    const dismissedAt = readSmartAppBannerDismissedAt();
    if (dismissedAt === null) {
        return false;
    }

    return now - dismissedAt < SMART_APP_BANNER_DISMISS_TTL_MS;
};

export const persistSmartAppBannerDismissedAt = (date = new Date()): void => {
    if (!isBrowser() || !hasStorage('localStorage')) {
        return;
    }

    window.localStorage.setItem(SMART_APP_BANNER_STORAGE_KEY, date.toISOString());
};
